module.exports = __webpack_public_path__ + "img/taptab.34a31b91.png";